module.exports = __webpack_public_path__ + "img/habbox.a05a0fe8.png";